export default __webpack_public_path__ + "static/media/university-undertones.df2b6ca3.mp3";